import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import UserCrown from '../../../../assets/images/user-crown.svg';
import Building from '../../../../assets/images/building.svg';
import Handbag from '../../../../assets/images/handbag.svg';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';
interface SectionSevenProps {
  section: OnboardingSummary;
}

const SectionSeven = ({ section }: SectionSevenProps) => {
  const { roleTitleResponsibilities, industriesOfInterest, cultureValues } =
    useOnboardingSummary({
      section,
    });
  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>Recruiting for a key role</div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={UserCrown}
              alt='HomeUser'
            />{' '}
            Role Title & Responsibilities:
          </div>
          <div className='text-lg'>{roleTitleResponsibilities}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={Handbag}
              alt='Handbag'
            />{' '}
            Key qualifications you're looking for:
          </div>
          <div className='text-lg'>{industriesOfInterest}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl col-span-2'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={Building}
              alt='Building'
            />{' '}
            Company culture fit or values:
          </div>
          <div className='text-lg'>{cultureValues}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionSeven;
